import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '@/components';

export const Route = createFileRoute('/admin/organization-info/_auth')({
  component: () => <RouteGuard can="manage" a="OrganizationInfo" />,
});
